import {
    PublicClientApplication,
    EventType,
    EventMessage,
    AuthenticationResult,
} from '@azure/msal-browser'
import { msalConfig } from 'app/authConfig'
import { logger } from 'app/logging/Logger'

export const msalInstance = new PublicClientApplication(msalConfig)

export const initialiseMsal = async () => {
    await msalInstance.initialize()
    const accounts = msalInstance.getAllAccounts()

    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0])
    }

    const eventCallbackId = msalInstance.addEventCallback(
        (event: EventMessage) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                const payload = event.payload as AuthenticationResult
                const account = payload.account
                msalInstance.setActiveAccount(account)
            }
        }
    )

    return () => {
        logger.debug('Removing MSAL event callback', {
            action: 'remove_msal_callback',
        })
        // addEventCallback returns null when no callback was registered.
        if (eventCallbackId) {
            msalInstance.removeEventCallback(eventCallbackId)
        }
    }
}
